<template>
	<div class="border-connectProBlue border-2 pl-8 pr-8 pb-8 pt-4 rounded min-h-72">
		<div class="flex space-x-16 border-b-2 pb-5">
			<div v-if="allowCustomerTab" :class="{ active: tab === 'customer' }" class="tab" @click="tab = 'customer'">
				{{ $t('customer') }}
			</div>
			<div v-if="allowDamageAssessorTab" :class="{ active: tab === 'damageassessor' }" class="tab" @click="tab = 'damageassessor'">
				{{ $t('damage_assessor') }}
			</div>
			<div v-if="allowRepairShopTab" :class="{ active: tab === 'repairshop' }" class="tab" @click="tab = 'repairshop'">
				{{ $t('repair_shop') }}
			</div>
			<div v-if="allowLawyerTab" :class="{ active: tab === 'lawyer' }" class="tab" @click="tab = 'lawyer'">
				{{ $t('lawyer') }}
			</div>
			<div :class="{ active: tab === 'misc' }" class="tab" @click="tab = 'misc'">
				{{ $t('other') }}
			</div>
		</div>

		<ProcessDocumentSentMailCardTab
			v-show="tab === 'repairshop' && allowRepairShopTab"
			:documents="$store.getters.getDocumentsRepairShop?.filter(doc => doc.uuid != null)"
			:title="$store.getters.repairShopLabel"
		/>
		<ProcessDocumentSentMailCardTab
			v-show="tab === 'customer' && allowCustomerTab"
			:documents="$store.getters.getDocumentsCustomer?.filter(doc => doc.uuid != null)"
			:title="$t('customer').toString()"
		/>
		<ProcessDocumentSentMailCardTab
			v-show="tab === 'damageassessor' && allowDamageAssessorTab"
			:documents="getDamageAssessorDocuments?.filter(doc => doc.uuid != null)"
			:title="$t('damage_assessor').toString()"
		/>
		<ProcessDocumentSentMailCardTab
			v-show="tab === 'lawyer' && allowLawyerTab"
			:documents="$store.getters.getDocumentsLawyer?.filter(doc => doc.uuid != null)"
			:is-system-lawyer="isSystemPartner"
			:title="$t('lawyer').toString()"
		/>
		<ProcessDocumentSentMailCardTab
			v-show="tab === 'misc'"
			:documents="$store.getters.getDocumentsMisc"
			:enable-add-button="true"
			:title="$t('other').toString()"
			@add="add"
		/>
		<div>
			<div class="font-bold text-left my-4">{{ $t('selected_documents') }}</div>
			<div class="flex flex-wrap mb-4">
				<div
					v-for="document in getCheckedDocuments"
					:key="document.id"
					@click="document.isChecked = false"
					class="cursor-pointer bg-connectProBlue text-white flex space-x-2 rounded-xl px-3 py-2 leading-none mr-4 mb-4 items-center"
				>
					<div class="text-connectProBlue rounded-full bg-white flex-shrink-0 w-4 h-4 flex justify-center items-center text-xs font-light">
						<font-awesome-icon :icon="['fa', 'times']" />
					</div>
					<div class="font-bold">
						{{ document.label }}
					</div>
				</div>
			</div>
			<div class="flex justify-end">
				<BaseButton class="btn-blue" @click="share">{{ $t('send_per_e_mail') }}</BaseButton>
			</div>
		</div>
		<ProcessDocumentSentMailToModal ref="sentMailTo" />
	</div>
</template>

<script>
import ProcessDocumentSentMailCardTab from '@/views/management/Process/Document/ProcessDocumentSentMailCardTab';
import ProcessDocumentSentMailToModal from '@/views/management/Process/Document/ProcessDocumentSentMailToModal';
import BaseButton from '@/components/forms/buttons/BaseButton';

export default {
	name: 'ProcessDocumentSentMailTab',
	components: { BaseButton, ProcessDocumentSentMailToModal, ProcessDocumentSentMailCardTab },
	data() {
		return {
			tab: 'customer',
		};
	},
	computed: {
		isOrderDocumentation() {
			return this.process?.process_type === 'order_documentation';
		},
		isSystemPartner() {
			return this.process.lawyerOffice?.is_system_partner;
		},
		getCheckedDocuments() {
			return this.$store.getters.getDocuments?.filter(x => x.isChecked) || [];
		},
		allowRepairShopTab() {
			return (
				this.$store.getters.getDocumentsRepairShop &&
				this.$store.getters.getDocumentsRepairShop.length &&
				this.process.repairShop &&
				this.process.repairShop.id
			);
		},
		allowLawyerTab() {
			return (
				this.$store.getters.getDocumentsLawyer &&
				this.$store.getters.getDocumentsLawyer.length &&
				this.$store.getters.getDamageCase.lawyerOffice &&
				!this.isOrderDocumentation
			);
		},
		allowDamageAssessorTab() {
			return this.$store.getters.getDocumentsDamageAssessor && this.$store.getters.getDocumentsDamageAssessor.length && !this.isOrderDocumentation;
		},
		allowCustomerTab() {
			return this.$store.getters.getDocumentsCustomer && this.$store.getters.getDocumentsCustomer.length;
		},
		process() {
			return this.$store.getters.getDamageCase;
		},
		getDamageAssessorDocuments() {
			return this.$store.getters.getDocumentsDamageAssessor?.filter(x => x.type !== 'damageassessor_documents');
		},
	},
	methods: {
		add() {
			this.$store.commit('addDocument', { label: this.$t('choose_document'), set: 'misc', type: 'misc' });
		},
		share() {
			if (this.getCheckedDocuments.length) {
				this.$refs['sentMailTo'].show(this.getCheckedDocuments).then(action => {
					if (action) {
						// if save
						this.getCheckedDocuments.forEach(e => (e.isChecked = false));
						this.$store.commit('setConfirmLeaving', false);
					}
				});
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('choose_least_one_document').toString());
			}
		},
	},
	created() {
		this.$store.dispatch('updateDocuments', { id: this.$route.params.processId });
	},
};
</script>

<style scoped>
.tab {
	@apply cursor-pointer text-lg text-gray-500 font-bold;
}

.tab.active {
	@apply relative text-black;
}

.tab.active:after {
	content: '';
	height: 0.1rem;
	@apply absolute left-0 right-0 bottom-0 -mb-1 bg-connectProBlue;
}
</style>
